import React, { useState } from "react"
import { Wrapper, Paragraph, Title, FoldWrapper, Question } from "./ProductsFaq.style"
import { useDetectDevice } from "../../../lib/useDetectDevice"
import { buildHtmlFromString } from "../../../lib/buildHtmlFromString"
import { v4 as uuidv4 } from "uuid"
import { ColoredLine } from "../ColorLine"
import { Icon } from "../Icon"

interface Props {
  id?: string
  data: any[]
  className?: string
}

export function ProductsFaqView({ id = "", data, className }: Props) {
  const isMobile = useDetectDevice()
  const classNames = (className && className) + " " + (isMobile && "mobile")

  if (!data?.length) return <></>

  return (
    <Wrapper id={id} className={classNames}>
      <ColoredLine />
      <Title>
        Vos questions, nos réponses
      </Title>

      {data &&
        data.map(item => <QuestionReponse key={uuidv4()} faqItem={item} />)}
    </Wrapper>
  )
}

const QuestionReponse = ({
  faqItem,
}: {
  question: string
  reponse: string
}) => {

  const [unfold, setUnfold] = useState(false);

  if (!unfold) {
    return (
      <FoldWrapper onClick={() => setUnfold(!unfold)}>
        <Question>{buildHtmlFromString(faqItem.question)}</Question>
        <Icon className={"active"}
          icon="chevron-right"
          size={20}
          color="#A4A4A4" />
      </FoldWrapper>)
  }
  return (
    <FoldWrapper onClick={() => setUnfold(!unfold)}>
      <div>
        <Question>{buildHtmlFromString(faqItem.question)}</Question>
        <Paragraph>{buildHtmlFromString(faqItem.reponse)}</Paragraph>
      </div>
      <Icon className={"active"}
        icon="chevron-up"
        size={20}
        color="#A4A4A4" />
    </FoldWrapper >
  )
}
